








import { Component, Vue } from 'vue-property-decorator'

@Component({
  name: 'BareLayout'
})
export default class extends Vue {
}
